import { Button, Card, Flex, List, Spin, Typography } from "antd";
import { useEffect, useState } from "react";
import { useToken } from "../../hooks/useToken";
import { useTheme } from "../../providers/ThemeProvider";
import { getUserPlaylists } from "../../services/integrations/spotify.service";

export function DashboardSpotify() {
  const { token } = useToken();
  const [playlists, setPlaylists] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [expanded, setExpanded] = useState<boolean>(false);
  const { message } = useTheme();

  useEffect(() => {
    setLoading(true);

    getUserPlaylists({
      onSuccess: (data) => {
        setPlaylists(data.items);
        setLoading(false);
      },
      onError: () => {
        message.error("Failed to fetch playlists");
        setLoading(false);
      },
    });
  }, []);

  return (
    <Flex
      align="flex-start"
      style={{
        flexDirection: "column",
        width: "100%",
        maxHeight: "100%",
        borderRadius: token.borderRadiusLG,
        backdropFilter: "blur(40px)",
        // backgroundColor: token.colorBgContainer,
        border: `2px solid ${token.colorBorderSecondary}`,
        padding: token.paddingMD,
      }}
    >
      <Typography
        style={{
          fontSize: token.fontSizeHeading4,
          fontWeight: token.fontWeightStrong,
          color: token.colorTextHeading,
          marginBottom: token.marginMD,
        }}
      >
        Yours Spotify Playlists
      </Typography>

      {loading && <Spin size="large" />}
      <List
        style={{ width: "100%" }}
        grid={{ gutter: 16, column: 4 }}
        dataSource={expanded ? playlists : playlists.slice(0, 8)}
        renderItem={(playlist) => (
          <List.Item>
            <Card
              hoverable
              cover={<img alt="playlist cover" src={playlist.images[0]?.url} />}
            >
              <Card.Meta
                title={playlist.name}
                description={
                  <Typography
                    style={{
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {playlist.owner.display_name}
                  </Typography>
                }
              />
            </Card>
          </List.Item>
        )}
      />
      {!expanded && playlists.length > 8 && (
        <Button style={{ marginTop: "16px" }} onClick={() => setExpanded(true)}>
          Show More
        </Button>
      )}
    </Flex>
  );
}
